import { AlertCircle, Newspaper } from "lucide-react";

import { SavedPostsEmptyAnimation } from "@/components/feed/saved-posts-empty-animation";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";

export function FeedLoadingState() {
  return (
    <div className="space-y-4" aria-busy="true" aria-live="polite">
      <section className="rounded-none border border-x-0 bg-card p-4 shadow-[0_1px_2px_rgba(16,24,40,0.04)] md:rounded-2xl md:border-x">
        <div className="flex items-start gap-3">
          <Skeleton className="size-10 rounded-full" />
          <div className="flex-1 space-y-3">
            <Skeleton className="h-20 w-full rounded-lg" />
            <div className="flex gap-2">
              <Skeleton className="h-8 w-24" />
              <Skeleton className="h-8 w-28" />
            </div>
          </div>
        </div>
      </section>
      {Array.from({ length: 3 }).map((_, index) => (
        <article key={index} className="rounded-none border border-x-0 bg-card p-4 shadow-[0_1px_2px_rgba(16,24,40,0.04)] md:rounded-2xl md:border-x">
          <div className="mb-3 flex items-start gap-3">
            <Skeleton className="size-10 rounded-full" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-40" />
              <Skeleton className="h-3 w-56" />
            </div>
          </div>
          <Skeleton className="mb-3 h-16 w-full" />
          <Skeleton className="h-9 w-full" />
        </article>
      ))}
    </div>
  );
}

export function FeedEmptyState({
  title = "Még nincsenek bejegyzések",
  description = "Légy te az első, aki megoszt egy szakmai kérdést, tapasztalatot vagy dokumentumot a kollégáiddal.",
  animation,
}: {
  title?: string;
  description?: string;
  animation?: boolean;
}) {
  return (
    <section className="rounded-none border border-x-0 border-dashed bg-card px-6 py-8 text-center md:rounded-2xl md:border-x">
      {animation ? (
        <SavedPostsEmptyAnimation />
      ) : (
        <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Newspaper className="size-6" />
        </div>
      )}
      <h2 className="text-base font-semibold">{title}</h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
        {description}
      </p>
    </section>
  );
}

export function FeedErrorState({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <section className="rounded-none border border-x-0 border-destructive/20 bg-card px-6 py-10 text-center md:rounded-2xl md:border-x">
      <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-destructive/10 text-destructive">
        <AlertCircle className="size-6" />
      </div>
      <h2 className="text-base font-semibold">A hírfolyam most nem elérhető</h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">{message}</p>
      {onRetry ? (
        <Button className="mt-4" onClick={onRetry} variant="outline">
          Újrapróbálás
        </Button>
      ) : null}
    </section>
  );
}

export function CommentsEmptyState() {
  return (
    <p className="px-1 py-2 text-sm text-muted-foreground">
      Még nincsenek hozzászólások. Szólj hozzá elsőként.
    </p>
  );
}

